const state = {
  alreadyShownPilotTooltip: false,
  isPilotListActive: false,
  isPilotPlayerActive: false,
  isPilotTooltipActive: false,
  isPilotPlayerExpanded: false,
  isPilotRecording: false,
  isPilotPlaying: false,
  isPilotPaused: false,
  isPilotSelfBrowsingMode: false,
  pilotList: [],
  currentPilotData: {},
  pauseTimestamp: 0,
  pilotTooltipOffset: { x: 0, y: 0 }
  // pilotData: {
  //   name: '',
  //   ownerId: '',
  //   ownerName: '',
  //   naviCollection: [{
  //     buildingId: '',
  //     panoramaId: '',
  //     panoramaName: '',
  //     pilotId: '',
  //     startTime: 0,
  //     duration: 0,
  //     videoUrl: '',
  //     naviData: {
  //       animation: false,
  //       history: [{
  //         floorplan: false,
  //         location: false,
  //         share: false,
  //         panoramaList: true,
  //         markerInfo: false,
  //         markerId: '',
  //         cameraH: 0,
  //         cameraV: 0,
  //         cameraFov: 120
  //       }]
  //     }
  //   }]
  // }
}

export const getters = {
  isPilotListActive: state => state.isPilotListActive,
  isPilotPlayerActive: state => state.isPilotPlayerActive,
  isPilotTooltipActive: state => state.isPilotTooltipActive,
  isPilotPlayerExpanded: state => state.isPilotPlayerExpanded,
  isPilotRecording: state => state.isPilotRecording,
  isPilotPlaying: state => state.isPilotPlaying,
  isPilotPaused: state => state.isPilotPaused,
  isPilotSelfBrowsingMode: state => state.isPilotSelfBrowsingMode,
  pilotList: state => state.pilotList,
  currentPilotData: state => state.currentPilotData,
  pauseTimestamp: state => state.pauseTimestamp,
  pilotTooltipOffset: state => state.pilotTooltipOffset,
  alreadyShownPilotTooltip: state => state.alreadyShownPilotTooltip
}

export const actions = {
  changeShownPilotTooltipState ({ commit, dispatch }, value) {
    commit('SET_ALREADY_SHOWN_PILOT_TOOLTIP', value)
  },
  showPilotList ({ commit, dispatch }) {
    commit('SET_PILOT_LIST_ACTIVE', true)
    // UI behavior
    dispatch('closePilotTooltip')
    dispatch('shrinkPilotPlayer')
  },

  closePilotList ({ commit }) {
    commit('SET_PILOT_LIST_ACTIVE', false)
  },

  togglePilotList ({ dispatch, getters }) {
    if (getters.isPilotListActive) {
      dispatch('closePilotList')
    } else {
      dispatch('showPilotList')
    }
  },

  showPilotTooltip ({ commit, state, dispatch }) {
    if (!state.alreadyShownPilotTooltip) {
      commit('SET_PILOT_TOOLTIP_ACTIVE', true)
    }
  },

  closePilotTooltip ({ commit }) {
    commit('SET_PILOT_TOOLTIP_ACTIVE', false)
  },
  showPilotPlayer ({ commit }) {
    commit('SET_PILOT_PLAYER_ACTIVE', true)
  },

  closePilotPlayer ({ commit }) {
    commit('SET_PILOT_PLAYER_ACTIVE', false)
  },

  togglePilotPlayer ({ dispatch, getters }) {
    if (getters.isPilotPlayerActive) {
      dispatch('closePilotPlayer')
    } else {
      dispatch('showPilotPlayer')
    }
  },

  expandPilotPlayer ({ commit }) {
    commit('SET_PILOT_PLAYER_EXPANDED', true)
  },

  shrinkPilotPlayer ({ commit }) {
    commit('SET_PILOT_PLAYER_EXPANDED', false)
  },

  togglePilotPlayerExpansion ({ dispatch, getters }) {
    if (getters.isPilotPlayerExpanded) {
      dispatch('shrinkPilotPlayer')
    } else {
      dispatch('expandPilotPlayer')
    }
  },

  startPilotRecorder ({ commit }) {
    commit('SET_PILOT_RECORDING', true)
  },

  stopPilotRecorder ({ commit }) {
    commit('SET_PILOT_RECORDING', false)
  },

  startPilotPlayer ({ commit }) {
    commit('SET_PILOT_PAUSED', false)
    commit('SET_PILOT_PLAYING', true)
  },

  stopPilotPlayer ({ commit }) {
    commit('SET_PILOT_PLAYING', false)
    commit('SET_PILOT_PAUSED', false)
  },

  pausePilotPlayer ({ commit }) {
    commit('SET_PILOT_PLAYING', false)
    commit('SET_PILOT_PAUSED', true)
  },

  setPilotList ({ commit }, data = []) {
    commit('SET_PILOT_LIST', data)
  },

  setCurrentPilotData ({ commit }, data = {}) {
    commit('SET_CURRENT_PILOT_DATA', data)
  },

  realPausePilotPlaying ({ commit }) {
    commit('UPDATE_PAUSE_TIMESTAMP')
  },

  turnOnPilotSelfBrowsingMode ({ commit, dispatch }) {
    commit('SET_PILOT_SELF_BROWSING_MODE', true)
    dispatch('shrinkPilotPlayer')
  },

  turnOffPilotSelfBrowsingMode ({ commit }) {
    commit('SET_PILOT_SELF_BROWSING_MODE', false)
  },

  togglePilotSelfBrowsingMode ({ dispatch, getters }) {
    if (getters.isPilotSelfBrowsingMode) {
      dispatch('turnOffPilotSelfBrowsingMode')
    } else {
      dispatch('turnOnPilotSelfBrowsingMode')
    }
  },

  setPilotTooltipOffset ({ commit }, data = {}) {
    commit('SET_PILOT_TOOLTIP_OFFSET', data)
  }
}

export const mutations = {
  SET_ALREADY_SHOWN_PILOT_TOOLTIP (state, bool = false) {
    state.alreadyShownPilotTooltip = bool
  },

  SET_PILOT_LIST_ACTIVE (state, bool = false) {
    state.isPilotListActive = bool
  },

  SET_PILOT_PLAYER_ACTIVE (state, bool = false) {
    state.isPilotPlayerActive = bool
  },

  SET_PILOT_TOOLTIP_ACTIVE (state, bool = false) {
    state.isPilotTooltipActive = bool
  },

  SET_PILOT_PLAYER_EXPANDED (state, bool = false) {
    state.isPilotPlayerExpanded = bool
  },

  SET_PILOT_RECORDING (state, bool = false) {
    state.isPilotRecording = bool
  },

  SET_PILOT_PLAYING (state, bool = false) {
    state.isPilotPlaying = bool
  },

  SET_PILOT_PAUSED (state, bool = false) {
    state.isPilotPaused = bool
  },

  SET_PILOT_LIST (state, data = []) {
    state.pilotList = data
  },

  SET_CURRENT_PILOT_DATA (state, data = {}) {
    state.currentPilotData = data
  },

  UPDATE_PAUSE_TIMESTAMP (state) {
    state.pauseTimestamp = (new Date()).getTime()
  },

  SET_PILOT_SELF_BROWSING_MODE (state, bool) {
    state.isPilotSelfBrowsingMode = bool
  },

  SET_PILOT_TOOLTIP_OFFSET (state, data) {
    state.pilotTooltipOffset = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
